<template>
  <div>
    <h2 class="title">{{ data.label }}</h2>
    <ul class="list" :class="{ 'not-Clickable': !clickable }">
      <li class="list__Item" v-for="answer in data.answers" :key="answer.id">
        <input class="radio" :name="data.id" type="radio" :value="answer.id" :id="answer.id" v-model="selected" />
        <label class="label" :for="answer.id" @click="selected === answer.id ? setValue(answer.id) : null"
          ><br />{{ answer.label }}</label
        >
      </li>
    </ul>
  </div>
</template>

<script>
import Slugify from '@/components/mixins/Slugify.js'

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    answers: {
      type: Array,
      default: () => [],
      required: true,
    },
    outcomes: {
      type: Array,
      default: () => [],
      required: true,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [Slugify],
  computed: {
    selected: {
      set(value) {
        this.setValue(value)
      },
      get() {
        const answer = this.answers.length > 0 && this.answers.find((a) => a.question_id === this.data.id)
        return answer && answer.answer_id
      },
    },
  },
  methods: {
    getIndex(index) {
      return this.slugify(`question-buttons-${this.data.label}-${index}`)
    },
    setValue(value) {
      const score = this.data.answers.findIndex((answer) => answer.id === value) + 1
      this.$emit('input', { question_id: this.data.id, answer_id: value, score, outcomes: this.outcomes })
    },
  },
}
</script>

<style lang="scss" scoped>
.list {
  all: unset;
  counter-reset: chapter;

  &.not-Clickable {
    pointer-events: none;
  }
}

.list__Item {
  display: block;
}

.radio {
  display: none;
}

.label {
  display: block;
  padding: 20px;
  cursor: pointer;
  background: white;
  color: black;
  border-radius: 8px;
  margin-bottom: 20px;
  position: relative;
  counter-increment: chapter;
  display: flex;
  align-items: center;
  transition: 100ms;
  font-size: 16px;

  &:hover {
    background: black;
    color: white;

    &::before {
      border: 2px solid rgba(white, 0.2);
    }
  }

  .radio:checked + & {
    background: var(--motyro-quiz-brand);
    color: white;

    &::before {
      border: 2px solid rgba(black, 0.2);
    }
  }

  &::before {
    padding: 5px 8px;
    text-transform: uppercase;
    display: inline-block;
    margin-right: 20px;
    border: 2px solid rgba(black, 0.2);
    content: counter(chapter, decimal);
    font-size: 11px;
    border-radius: 5px;
    transition: 100ms;
    font-weight: bold;
  }

  @media only screen and (max-width: 768px) {
    display: block;
    font-size: 14px;

    &::before {
      margin-bottom: 10px;
    }
  }
}
</style>
